import Vue from 'vue';
import {helpers} from './../../helpers';

export default {
    store: {
        namespaced: true,
        state: {
            customers: [],
            groups:[],
            group: {},
            customer: {},
            customers_ul: {},
            customers_fl: {},
            customerFinance: []
        },
        actions: {
            //получение контрагента
            getCustomerById({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, '/customers/byid/' + id).then(r => {
                    Vue.set(state, 'customer', r);
                    return r;
                });
            },

            getCustomerFinance({ state, rootState }, id) {
                return helpers.http.get({context: this, rootState}, `/customers/byid/${id}/finances`).then(r => {
                    Vue.set(state, 'customerFinance', r);
                    return r;
                });
            },

            //обновление данных контрагента из ДаДата
            updateCustomerFromDaData({ rootState }, id) {
                return helpers.http.put({context: this, rootState}, `/customers/byid/${id}/update-dadata`);
            },

            suggestCustomersByInn({ rootState }, data) {
                let searchString = data.inn.replace(/['"«»]/g, ''), existHid = data.existHid;
                if (!existHid) existHid = [];

                return helpers.http.get({context: this, rootState}, '/suggest', {params: {
                    count: 10, type: 'party', query: searchString
                }}).then(r => {
                    if (!r) return [];
                    let result = [], customers = [];

                    if (r.value) result.push(r);
                    else result = Object.assign([], r);
                    if (!result.length) return [];

                    result.filter(item => !(existHid.indexOf(item.data.hid)+1)).map(item => {
                        let info = item.data;

                        let opf  = '';
                        let name = '';
                        let fullname = '';

                        if (!opf  && info.opf  && info.opf.short)  opf  = info.opf.short;
                        if (!opf  && info.opf  && info.opf.full)   opf  = info.opf.full;
                        if (!name && info.name && info.name.full)  name = info.name.full;
                        if (!name && info.name && info.name.short) name = info.name.short;

                        if (!fullname && info.name && info.name.short_with_opf) fullname = info.name.short_with_opf;
                        if (!fullname && name && opf) fullname = opf + ' "' + name + '"';
                        if (!fullname && info.name && info.name.full_with_opf) fullname = info.name.full_with_opf;

                        customers.push({
                            id:   null,
                            hid:  info.hid,
                            name: fullname,
                            inn:  info.inn,
                            kpp:  info.kpp,
                            type: (info.type === "INDIVIDUAL") ? '3' : '1',
                            passport_number:  null,
                            checking_account: null,
                            correspondent_account: null,
                            bic:   null,
                            bank:  null,
                            phone: null,
                            email: null,
                            sort:  100,
                            nds: 0,
                            attached_contacts: [],
                            address_legal: (info.address && info.address.value) ? info.address.value : null,
                            addresses: [],
                            contacts: []
                        });
                    });

                    return customers;
                });
            },

            //получение контрагента по ИНН
            getCustomerByInn({ dispatch, rootState }, data) {
                let searchString = data.inn.replace(/['"«»]/g, '');
                data = {
                    filter: [
                        ['inn',  '%', searchString], 'or',
                        ['inn',  '%', searchString.replace(/[^0-9]/g, '')], 'or',
                        ['name', '%', searchString]
                    ]
                };

                return helpers.http.get({context: this, rootState}, '/customers', {params: data}).then(customers => {
                    if (!Array.isArray(customers) && customers.data) customers = Object.assign([], customers.data);
                    let dbHid = customers.map(item => item.hid);
                    return dispatch('suggestCustomersByInn', { inn: searchString, existHid: dbHid }).then(suggest => {
                        customers = customers.concat(suggest);
                        return customers;
                    });
                });
            },

            //получение контрагента по номеру паспорта
            getCustomerByPassport({ dispatch, rootState }, data) {
                let searchString = data.passport_number.replace(/['"«»]/g, '');
                data = {
                    filter: [
                        ['passport_number', '%', searchString], 'or',
                        ['passport_number', '%', searchString.replace(/[^0-9]/g, '')], 'or',
                        ['name', '%', searchString]
                    ]
                };

                return helpers.http.get({context: this, rootState}, '/customers', {params: data}).then(r => {
                    let customer = {};
                    if (r.length > 0) customer = r[0];
                    else return null;

                    return dispatch('getCustomerContacts', { customer_id: customer.id }).then(contacts => {
                        customer.contacts = contacts;
                        return customer;
                    });
                });
            },

            //поиск контрагентов
            searchCustomers({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/search/customers', {params: data});
            },
            
            //поиск контрагентов
            searchAndSuggestCustomers({ rootState, dispatch }, data) {
                return helpers.http.get({context: this, rootState}, '/search/customers', {params: data}).then(async r => {
                    if (r && r.length) return r
                    else return (await dispatch('suggestCustomersByInn', { inn: data.search }));
                });
            },

            //получение контрагентов
            getCustomers({ state, rootState }, data) {
                const concat = (data && data.concat) ? data.concat : false
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/customers', {params: data}).then(r => {
                    if (!r || !r.data) return [];
                    let customers = r.data;

                    if (concat) {
                        let temp = (state && state.customers) ? state.customers : [];
                        customers = Object.assign([], temp.concat(customers));
                    }

                    Vue.set(state, 'customers', customers);
                    Vue.set(state, 'customers_amount', r.total);

                    return customers;
                });
            },

            getULCustomers({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);

                if (data.filter.model && data.filter.model.length) {
                    data.filter.model.push("and");
                    data.filter.model.push(["type","=", [1,3]]);
                }

                return helpers.http.get({context: this, rootState}, '/customers', {params: data}).then(r => {
                    Vue.set(state, 'customers_ul', r);
                    return r;
                });
            },

            getFLCustomers({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);

                if (data.filter.model && data.filter.model.length) {
                    data.filter.model.push("and");
                    data.filter.model.push(["type","=", "2"]);
                }

                return helpers.http.get({context: this, rootState}, '/customers', {params: data}).then(r => {
                    Vue.set(state, 'customers_fl', r);
                    return r;
                });
            },


            //добавление контрагента
            addCustomer({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/customers', data.customer);
            },

            //обновление контрагента
            updateCustomer({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/customers', data.customer);
            },

            //удаление контрагента
            deleteCustomer({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, '/customers/byid/' + id)
            },

            //получение контактных данных
            getCustomerContact({ rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/customers/contacts/byid/' + data.id);
            },

            //добавление контактных данных
            addCustomerContacts({ rootState }, data) {
                let contacts = data.contacts;
                return helpers.http.post({context: this, rootState}, '/customers/contacts', contacts);
            },

            //обновление контактных данных
            updateCustomerContacts({ rootState }, data) {
                return helpers.http.put({context: this, rootState}, '/customers/contacts', data.contacts);
            },

            //удаление контактных данных
            deleteCustomerContacts({ rootState }, data) {
                return helpers.http.delete({context: this, rootState}, '/customers/contacts/byid/' + data.contact_id);
            },

            //получение групп клиентов
            getCustomerGroups({ state, rootState }, data) {
                data = helpers.db.resolveGetParams(data);
                return helpers.http.get({context: this, rootState}, '/customers/group', {params: data}).then(r => {
                    Vue.set(state, 'groups', r.data);
                    Vue.set(state, 'groups_amount', r.total);
                    return r.data;
                });
            },

            //получение группы клиентов
            getCustomerGroup({ state, rootState }, data) {
                return helpers.http.get({context: this, rootState}, '/customers/group/byid/' + data.id).then(r => {
                    Vue.set(state, 'group', r);
                    return r;
                });
            },

            //добавление группы клиентов
            addCustomerGroup({ rootState }, group) {
                return helpers.http.post({context: this, rootState}, '/customers/group', group);
            },

            //обновление группы клиентов
            updateCustomerGroup({ rootState }, group) {
                return helpers.http.put({context: this, rootState}, '/customers/group', group);
            },

            //удаление группы клиентов
            deleteCustomerGroup({ rootState }, id) {
                return helpers.http.delete({context: this, rootState}, `/customers/group/byid/${id}`);
            },

            //прикрепление пользователя к группе
            attachToGroup({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/customers/group/attach', {
                    customer_id: data.customerId,
                    group_id:    data.groupId
                });
            },

            //открпление пользователя от группы
            detachFromGroup({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/customers/group/detach', {
                    customer_id: data.customerId,
                    group_id:    data.groupId
                });
            },

            //прикрепление адреса
            attachAddress({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/customers/addresses/attach', data);
            },

            //открепление адреса
            detachAddress({ rootState }, data) {
                return helpers.http.post({context: this, rootState}, '/customers/addresses/detach', data);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/customers/store.js